import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var Event = /*#__PURE__*/_createClass(function Event(event) {
  _classCallCheck(this, Event);
  _defineProperty(this, "type", void 0);
  _defineProperty(this, "value", void 0);
  _defineProperty(this, "ttl", void 0);
  _defineProperty(this, "timestamp", void 0);
  _defineProperty(this, "id", void 0);
  this.type = event.type;
  this.ttl = event.ttl;
  this.value = event.value;
  this.timestamp = Date.now();
});